import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import './PlainLayout.scss';
import {
    AlertBanner,
    SiteLayoutAlert,
    LoadingBar,
    useInternetExplorer,
    RotatingDotsLoader,
} from '@cc/common';
import classnames from 'classnames';

const PlainLayout = ({ children }) => {
    const isInternetExplorer = useInternetExplorer();

    return (
        <div className={classnames('plain-layout', isInternetExplorer ? 'browser-ie' : undefined)}>
            <SiteLayoutAlert>
                <AlertBanner />
            </SiteLayoutAlert>
            <LoadingBar isPromiseIndicator />
            <div className="plain-layout__content">
                <Suspense fallback={<RotatingDotsLoader />}>{children}</Suspense>
            </div>
        </div>
    );
};

PlainLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default PlainLayout;
